// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white-container {
  position: absolute;
  background-color: white;
  height: auto;
  min-width: 40%;
  padding: 2.5em;
  box-shadow: 0px 1px 1px rgba(0, 51, 102, 0.12), 0px 3px 6px -1.5px rgba(0, 51, 102, 0.17);
}

.wc-onboarding .wc-container {
  min-height: 520px;
  padding: 0px 40px 0 40px;
  background-color: white;
}
.wc-onboarding .page-background {
  height: unset;
}

@media (min-width: 1025px) {
  .white-container {
    top: 14%;
    left: 55%;
    width: 40%;
  }
}
@media (min-width: 915px) and (max-width: 1024px) {
  .white-container {
    top: 10%;
    left: 33%;
    width: 33%;
  }
}
@media (min-width: 481px) and (max-width: 914px) {
  .white-container {
    position: unset;
    display: block;
    margin: 0 auto;
  }
}
@media (max-width: 480px) {
  .white-container {
    position: unset;
    display: block;
    margin: 0 auto;
  }
}
.page-background {
  background: url('background.648e61106a92a55e.svg') 50% 50% no-repeat;
  background-size: cover;
  height: 76vh;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
